<template>
  <InteractionStep :disabled-next="!inputs.date.value"
                   :pending-next="pendingSave"
                   @next="onSave">
    <template v-slot:content>
      <div class="step-information">
        <div class="step-information__section _mod">
          <div class="step-information__block">
            <DatePiker :label="$tInteraction('Date of visit')"
                       v-model="inputs.date.value"
                       class="step-information__block-row _green"
            />
          </div>
        </div>
      </div>
    </template>

  </InteractionStep>
</template>

<script>
  import InteractionStep from '../InteractionStep'
  import DatePiker from '../../DatePiker'
  import {http} from "../../../axios"
  import interactionStepMixin from "@/mixins/interactionStepMixin"

  export default {
    name: 'InteractionStepDataEmployer',
    mixins: [interactionStepMixin],
    components: {
      InteractionStep,
      DatePiker
    },
    data() {
      return {
        error: null,
        pendingSave: false,
        inputs: {
          date: {
            value: null
          },
        }
      }
    },
    methods: {
      onSave() {
        this.error = null
        this.pendingSave = true

        const step = this.$store.state.interaction.step
        const sendData = {
          visit_date: this.inputs.date.value
        }

        http.post(`/api/new-interaction/${this.$route.params.id}/${step}`, sendData).then(async () => {
          await this.$store.dispatch('interaction/loadInteraction')
        }).catch(e => {
          this.handleInteractionError(e)
        }).finally(() => {
          this.pendingSave = false
        })
      }
    }
  }
</script>

<style>

</style>
